import { Checkbox, Col, Form, message, Modal, Row } from "antd";
import dayjs from "dayjs";
import { object } from "prop-types";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  getAllDepartmentList,
  getClientid,
  getIsShowAgain,
  getLocations,
} from "redux/selectors";
import styled from "styled-components";
import { ReactComponent as Edit } from "../../assets/Edit_Pencil_01.svg";
import { ReactComponent as Trash } from "../../assets/trash.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { STATUS_CODE } from "common/Constants";
import { CALL_API } from "common/API";
const StyledModal = styled(Modal)`
  small {
    color: #636980;
  }
`;

const ShiftInfo = ({
  open,
  setOpen,
  data = {},
  getShiftList = () => {},
  shiftColors = [],
  showDeleteConfirm = () => {},
  Menulist,
}) => {
  const departmentList = useSelector(getAllDepartmentList);
  const getShowAgain = useSelector(getIsShowAgain);
  const locationList = useSelector(getLocations);
  const ClientId = useSelector(getClientid);
  const history = useHistory();

  const weekendOptions = [
    { label: "All Saturdays and Sundays", value: "allsaturdayandsunday" },
    { label: "All Saturdays", value: "allsaturdays" },
    { label: "All Sundays", value: "allsundays" },
    { label: "All Days", value: "alldays" },
    { label: "No Weekends", value: "noweekends" },
  ];

  const transformData = useMemo(() => {
    return {
      "Shift Title": data?.shifttitle || "-",
      "Shift Code": data?.shiftcode || "-",
      "Shift Hours":
        dayjs(data?.starts).format("hh:mm A") +
        " - " +
        dayjs(data?.ends).format("hh:mm A"),
      "Shift Status": data?.status || "-",
      // Location:
      //   locationList
      //     ?.filter((val) =>
      //       data?.location?.some((locId) => locId === val.location_id)
      //     )
      //     ?.map((item) => item?.location_name)
      //     ?.join(", ") || "-",
      // Department:
      //   departmentList
      //     ?.filter((val) =>
      //       data?.department?.some((deptId) => deptId === val.department_id)
      //     )
      //     ?.map((item) => item?.department_name)
      //     ?.join(", ") || "-",
      Weekend:
        weekendOptions?.find((val) => val?.value === data?.isweekend)?.label ||
        "-",
    };
  }, [data, locationList, departmentList]);

  return (
    <div>
      <StyledModal
        title={
          <div className="d-flex justify-content-between align-items-center">
            <strong>Shift Info</strong>
            <div className="mx-4">
              {Menulist?.find(
                (item) =>
                  item?.key === "manage" &&
                  item?.subMenu.find(
                    (subItem) =>
                      subItem?.key === "shift" && subItem?.permission.edit
                  )
              ) && (
                <Edit
                  style={{ cursor: "pointer", marginRight: "10px" }}
                  corlor="red"
                  onClick={() =>
                    history?.push("editshift", {
                      shiftData: data,
                      shiftColors: shiftColors,
                    })
                  }
                />
              )}
              {Menulist?.find(
                (item) =>
                  item?.key === "manage" &&
                  item?.subMenu.find(
                    (subItem) =>
                      subItem?.key === "shift" && subItem?.permission.delete
                  )
              ) && (
                <Trash
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    showDeleteConfirm(data?.shift_id);
                    setOpen(false);
                  }}
                />
              )}
            </div>
          </div>
        }
        open={open}
        onCancel={() => setOpen(false)}
        width={500}
        footer={false}
      >
        <Row gutter={[8, 8]}>
          {Object.keys(transformData).map((key, index) => (
            <React.Fragment key={index}>
              <Col span={12}>{key}</Col>
              <Col span={12}>
                {" "}
                <div className="d-flex align-items-center gap-2">
                  <strong style={{ fontWeight: 500 }}>
                    {transformData[key]}{" "}
                  </strong>
                  {key === "Shift Title" && (
                    <div
                      style={{
                        color: "#636980",
                        width: "20px",
                        height: "20px",
                        background: data?.color,
                      }}
                    ></div>
                  )}
                </div>
              </Col>
            </React.Fragment>
          ))}
        </Row>
      </StyledModal>
    </div>
  );
};

export default ShiftInfo;
